import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section py-5 hero-bg">
    </section>
  );
};

export default HeroSection;


// import React from 'react';
// import './HeroSection.css';

// const HeroSection = () => {
//   return (
//     <section className="hero-section py-5 hero-bg">
//       <div className="container ">
//         <div className="row align-items-center">
          
//           {/* Left Column - Text */}
//           <div className="col-md-8 mb-4 mb-md-0 ">
//             <h1 className="hero-title mb-3">
//             <span className="highlights">LENTO INDIA</span><br/>
//               House Of Green Energy <br />
              
//             </h1>
//             <p className="mb-4 hero-description">
//               Get Your Solar System Installed & Running Smoothly Today!.
//             </p>
//           </div>

//           {/* Right Column - Enquiry Form */}
//           <div className="col-md-4">
//             <div className="card shadow p-4 enquiry-form">
//               <h4 className="mb-3">Get In Touch</h4>
//               <form>
//                 <div className="mb-3">
//                   <input type="text" className="form-control" placeholder="Enter your name" />
//                 </div>
//                 <div className="mb-3">
//                   <input type="email" className="form-control" placeholder="Enter your email" />
//                 </div>
//                 <div className="mb-3">
//                   <input type="tel" className="form-control" placeholder="Enter your phone" />
//                 </div>
//                 <div className="mb-3">
//                   <input type="textarea" className="form-control" placeholder="Enter Your Message" />
//                 </div>
//                 <button type="submit" className="btn btn-success w-100">Submit</button>
//               </form>
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;
